import React from "react";
import { Link } from "gatsby";

const AnswerButton = props => {
  return (
    <Link to={props.linkTo} onClick={e => props.onClick(e)} className="answer">
      {props.text}
    </Link>
  );
};

export default AnswerButton;
